<template>
  <div class="container-fluid mycontainer-fluid page-content">
    <div v-if="listQuestionConference.IS_VIEW_PHILTER" class="wrapper-header">
      <form>
        <div class="row myrow filter-wrapper-stl">
          <div class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder">
            <template v-if="listQuestionConference.SP_TYPE_SOVET.length == 1">
              <select
                id="filter_type_sovet"
                class="form-control filter-select-stl"
                :disabled="true"
                style="background-image: none"
              >
                <option
                  :value="listQuestionConference.SP_TYPE_SOVET[0].ID"
                  :key="listQuestionConference.SP_TYPE_SOVET[0].ID"
                  v-text="listQuestionConference.SP_TYPE_SOVET[0].NAME"
                  selected
                >
                </option>
              </select>
            </template>
            <template v-else>
              <select
                id="filter_type_sovet"
                class="form-control filter-select-stl"
                v-model="filter.UF_TYPE_SOVET_ID"
                @change="resetSpNumber"
                style="background-image: none"
              >
                <option value="" disabled selected>Тип совета</option>
                <option
                  v-for="item in listQuestionConference.SP_TYPE_SOVET"
                  :value="item.ID"
                  :key="item.ID"
                  v-text="item.NAME"
                />
              </select>
            </template>
          </div>
          <div class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder">
            <select
              v-if="listQuestionConference.SP_TYPE_SOVET.length == 1"
              id="filter_type_question"
              class="form-control filter-select-stl"
              v-model="filter.ID"
              style="background-image: none"
            >
              <option value="" disabled selected>Выбор № совета</option>
              <option
                v-for="item in listQuestionConference.SP_NUMBER_SOVET"
                v-show="
                  item.UF_TYPE_SOVET_ID ==
                    listQuestionConference.SP_TYPE_SOVET[0].ID
                "
                :value="item.ID"
                :key="item.ID"
                v-text="'№ ' + item.UF_NUMBER + ' ' + item.UF_DATE_SOVET_RU"
              />
            </select>

            <select
              v-else
              id="filter_type_question"
              class="form-control filter-select-stl"
              v-model="filter.ID"
              :disabled="!filter.UF_TYPE_SOVET_ID"
              style="background-image: none"
            >
              <option value="" disabled selected>Выбор № совета</option>
              <option
                v-for="item in getSpNumberSovet"
                :value="item.ID"
                :key="item.ID"
                v-text="'№ ' + item.UF_NUMBER + ' ' + item.UF_DATE_SOVET_RU"
              />
            </select>
          </div>
          <div
            :class="{
              'filter-btn-container': isSmail
            }"
          >
            <div class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder">
              <button
                type="button"
                class="project-filter__butt-btn butt-new-style butt-new-style-reset stl-w-full"
                @click="resetFilters"
              >
                СБРОС
              </button>
            </div>
            <div class="col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder">
              <button
                type="button"
                class="project-filter__butt-btn butt-new-style stl-w-full"
                :disabled="
                  listQuestionConference.SP_TYPE_SOVET.length == 1 && filter.ID
                    ? false
                    : !filter.UF_TYPE_SOVET_ID || !filter.ID
                    ? true
                    : false
                "
                @click="SetPhilter"
              >
                Применить
              </button>
            </div>
          </div>
          <div
            :class="{
              'col-xs-12 col-md-3 col-lg-2 mycol-l filter-stl-holder control-stl-holder': true,
              'pull-right': isDesktop
            }"
            v-if="listQuestionConference.IS_VIEW_FILE_SOSTAV_SOVET"
          >
            <a
              v-if="
                listQuestionConference.SOVET_INFO.UF_SOSTAV_SOVET_FILE_LINK !=
                  ''
              "
              class="project-filter__butt-btn butt-new-style butt-new-style-reset stl-w-full btn-spisoc-exp-sostav"
              :class="
                listQuestionConference.SOVET_INFO.UF_SOSTAV_SOVET_FILE_ID == 0
                  ? ' disabled'
                  : ''
              "
              :href="
                listQuestionConference.SOVET_INFO.UF_SOSTAV_SOVET_FILE_LINK
              "
              target="_blank"
            >
              <i class="exp-doc-file exp-doc-file__smail"></i>
              {{ listQuestionConference.TEXT_FILE_SOSTAV_SOVET }}
            </a>
            <a
              v-else
              class="project-filter__butt-btn butt-new-style butt-new-style-reset stl-w-full btn-spisoc-exp-sostav"
              :class="
                listQuestionConference.SOVET_INFO.UF_SOSTAV_SOVET_FILE_ID == 0
                  ? ' disabled'
                  : ''
              "
              @click="
                openDoc(
                  listQuestionConference.SOVET_INFO.UF_SOSTAV_SOVET_FILE_ID
                )
              "
            >
              <i class="exp-doc-file exp-doc-file__smail"></i>
              {{ listQuestionConference.TEXT_FILE_SOSTAV_SOVET }}
            </a>

            <a
              v-if="listQuestionConference.IS_VIEW_EDIT_FILE_SOSTAV_SOVET"
              @click="sUploaderFileSovet"
              class="icon-item icon-edit-link"
            ></a>

            <a
              v-if="
                listQuestionConference.IS_VIEW_EDIT_FILE_SOSTAV_SOVET &&
                  listQuestionConference.SOVET_INFO.UF_SOSTAV_SOVET_FILE_ID > 0
              "
              @click="sDeleteFileSovetDialog"
              class="icon-item icon-delete-link"
            ></a>
          </div>
        </div>
      </form>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <div class="container-flex container-flex-card row myrow">
          <div
            class="container-col col-xs-12 col-md-12 col-lg-12 mycol"
            style="margin-right: 0px;"
          >
            <div class="container-stl container-stl-card">
              <div class="table-responsive">
                <table
                  v-if="!isLoading"
                  class="table-question-list table-question-list--sm"
                >
                  <thead class="table-question-list__thead">
                    <th colspan="3" class="table-question-list__thead-name">
                      Вопрос
                    </th>
                    <th
                      v-if="
                        listQuestionConference.IS_VIEW_CONTROLLER_SET_NEW_SIGN ===
                          1
                      "
                      class="table-question-list__thead-switch"
                    >
                      Новый
                    </th>
                    <th class="table-question-list__thead-archive">
                      <div
                        v-if="listQuestionConference.IS_VIEW_BUTTON_ARHIVR_ALL"
                        @click="getArchiveAll()"
                        class="doc-arcive-box"
                        style="cursor: pointer; width:80px;"
                      >
                        <button
                          type="button"
                          class="butt-stl butt-blue"
                          style="height:32px; font-size: 12px;"
                        >
                          Скачать все
                        </button>
                        <!--Архив &nbsp;
                    <div class="icon-item-archive" />-->
                      </div>
                      <div v-else>
                        Архив
                      </div>
                    </th>
                    <th
                      v-if="listQuestionConference.IS_VIEW_COLUMN_VOITING === 1"
                      class="table-question-list__thead-button"
                    >
                      Голосование
                    </th>
                  </thead>
                  <tbody v-if="listQuestionConference.counts === 0">
                    <tr class="table-question-list__tbody-container">
                      <td  class="table-question-list__tbody-name"
                           colspan="3">{{listQuestionConference.TITLE_ROW_NOT_FOUND}}
                      </td>
                    </tr>
                  </tbody>
                  <tbody
                    v-for="(item, index) in listQuestionConference.items"
                    :key="index"
                    class="table-question-list__tbody"
                    :class="
                      !isCloseRowQuestionArr ||
                      (isCloseRowQuestionArr &&
                        !isCloseRowQuestionArr[item.QUESTION.ID])
                        ? ''
                        : 'active'
                    "
                  >
                    <tr class="table-question-list__tbody-container">
                      <td
                        colspan="3"
                        class="table-question-list__tbody-name"
                        @click="closeQuestion(item.QUESTION.ID)"
                      >
                        <template
                          v-if="item.QUESTION.UF_IS_DELETE_AFTER_VIEW_SOVET"
                        >
                          <i
                            class="open-conteiner-icon"
                            style="background: none;"
                          />
                          {{ item.QUESTION.UF_SORT }}.
                          <span
                            v-html="
                              item.QUESTION.CURRENT_PAGE_VOTE_QUESTION_NAME
                            "
                          ></span>
                        </template>
                        <a
                          href="javascript:void(0)"
                          class="table-question-link"
                          v-else
                        >
                          <i class="open-conteiner-icon" />
                          {{ item.QUESTION.UF_SORT }}.
                          {{ item.QUESTION.CURRENT_PAGE_VOTE_QUESTION_NAME }}
                          <sup v-if="item.QUESTION.UF_IS_NEW" class="new_doc"
                            >новый</sup
                          >
                        </a>
                      </td>
                      <td
                        v-if="
                          listQuestionConference.IS_VIEW_CONTROLLER_SET_NEW_SIGN ===
                            1
                        "
                      />
                      <td style="padding-left: 70px;">
                        <div
                          v-if="!item.QUESTION.UF_IS_DELETE_AFTER_VIEW_SOVET"
                          @click="getArchive(item.QUESTION.ID)"
                          class="doc-arcive-box"
                          style="cursor: pointer; width:80px;"
                        >
                          <div class="icon-item-archive" />
                          <span class="doc-arcive-box__count"
                            >({{ item.DOC_LIST_COUNT }})</span
                          >
                        </div>
                      </td>
                      <td
                        v-if="
                          listQuestionConference.IS_VIEW_COLUMN_VOITING === 1
                        "
                        class="table-question-list__tbody-button"
                      >
                        <div class="vote-controll df-ac">
                          <button
                            v-for="(voice,
                            index) in listQuestionConference.SP_TYPE_VOIСE"
                            :key="index"
                            type="button"
                            class="butt-stl vote-controll-item butt-vote-behind"
                            :class="[
                              listQuestionConference.IS_ACTIVE_AREA_VOITING
                                ? ''
                                : 'butt-vote-disabled',
                              voice.UF_CLASS_BUTTON,
                              item.VOTE_USER_INFO &&
                              item.VOTE_USER_INFO[item.QUESTION.ID] &&
                              item.VOTE_USER_INFO[item.QUESTION.ID].RESULT &&
                              item.VOTE_USER_INFO[item.QUESTION.ID].RESULT
                                .UF_RESULT_VOTE_ID === voice.ID
                                ? 'active'
                                : ''
                            ]"
                            :disabled="
                              !listQuestionConference.IS_ACTIVE_AREA_VOITING
                            "
                            @click="
                              setVoice(
                                item.QUESTION.ID,
                                voice.ID,
                                item.VOTE_USER_INFO[item.QUESTION.ID].RESULT
                                  .UF_RESULT_VOTE_ID
                              )
                            "
                          >
                            {{ voice.UF_NAME }}
                          </button>
                          <a
                            v-if="
                              item.VOTE_USER_INFO &&
                                item.VOTE_USER_INFO[item.QUESTION.ID] &&
                                item.VOTE_USER_INFO[item.QUESTION.ID].HISTORY
                            "
                            @click="openHistoryModal(item, item.QUESTION.ID)"
                            class="icon-item status-history"
                          />
                        </div>
                      </td>
                    </tr>
                    <!-- режим вывода документов в виде группированного списка -->
                    <template
                      v-if="
                        item.isGroupDocuments &&
                          !item.QUESTION.UF_IS_DELETE_AFTER_VIEW_SOVET
                      "
                    >
                      <template
                        v-for="itemGr in listQuestionConference.groupList"
                      >
                        <tr class="table-question-list__tbody-tr-result">
                          <td
                            colspan="3"
                            :style="
                              itemGr.IS_CLOSE ? 'padding-left: 70px;' : ''
                            "
                          >
                            <a
                              href="javascript:void(0)"
                              v-if="itemGr.IS_CLOSE"
                              @click="
                                closeDopDocByQuestion(item.QUESTION.ID, $event)
                              "
                              class="table-question-link"
                              :class="
                                isCloseRowQuestionArrDopDoc &&
                                isCloseRowQuestionArrDopDoc[item.QUESTION.ID]
                                  ? 'close-area'
                                  : ''
                              "
                            >
                              <i class="open-conteiner-icon-dop" />
                              <b>{{ itemGr.NAME }}</b>
                            </a>
                            <b v-else>{{ itemGr.NAME }}</b>
                          </td>
                        </tr>
                        <!-- сами документы группы -->
                        <template
                          v-for="(itemL1, indexL1) in item.DOCUMENTS_LIST_GROUP"
                        >
                          <tr
                            v-for="(doc, index) in itemL1"
                            :key="index"
                            v-if="
                              indexL1 == itemGr.ID &&
                                (!itemGr.IS_CLOSE ||
                                  (itemGr.IS_CLOSE &&
                                    isCloseRowQuestionArrDopDoc &&
                                    isCloseRowQuestionArrDopDoc[
                                      item.QUESTION.ID
                                    ]))
                            "
                            class="table-question-list__tbody-tr-result"
                          >
                            <td>{{ doc.UF_GROUP_SORT }}. {{ doc.UF_NAME }}</td>
                            <td style="min-width: 100px;">
                              <a
                                v-if="
                                  doc.UF_IS_AUTO_GENERATE == 1 &&
                                    doc.FILE_FULL_INFO !== ''
                                "
                                :href="doc.FILE_FULL_INFO"
                                target="_blank"
                                class="stl-link-black table-doc__status-link"
                                style="cursor: pointer"
                              >
                                <i class="exp-doc-file" />
                              </a>
                              <div
                                v-else-if="doc.UF_IS_AUTO_GENERATE == 1"
                                @click="openGeneretaDoc(doc.ID)"
                                class="stl-link-black"
                                style="cursor: pointer"
                              >
                                <i class="exp-doc-file" />
                              </div>
                              <a
                                v-else-if="doc.FILE_FULL_INFO != ''"
                                :href="doc.FILE_FULL_INFO"
                                target="_blank"
                                class="stl-link-black table-doc__status-link"
                                style="text-decoration: none;cursor: pointer"
                              >
                                <i
                                  v-if="doc.UF_EXT === 'pdf'"
                                  class="exp-doc-file"
                                />
                                <i
                                  v-else-if="
                                    doc.UF_EXT === 'doc' ||
                                      doc.UF_EXT === 'docx'
                                  "
                                  class="docs-doc-icon-sovet"
                                />
                                <i
                                  v-else-if="
                                    doc.UF_EXT === 'xls' ||
                                      doc.UF_EXT === 'xlsx'
                                  "
                                  class="xls-doc-icon"
                                />
                                <i v-else class="exp-doc-file" />
                              </a>
                              <a
                                v-else-if="doc.UF_FILE_ID > 0"
                                @click="openDoc(doc.UF_FILE_ID)"
                                class="stl-link-black table-doc__status-link"
                                style="text-decoration: none;cursor: pointer"
                              >
                                <i
                                  v-if="doc.UF_EXT === 'pdf'"
                                  class="exp-doc-file"
                                />
                                <i
                                  v-else-if="
                                    doc.UF_EXT === 'doc' ||
                                      doc.UF_EXT === 'docx'
                                  "
                                  class="docs-doc-icon-sovet"
                                />
                                <i
                                  v-else-if="
                                    doc.UF_EXT === 'xls' ||
                                      doc.UF_EXT === 'xlsx'
                                  "
                                  class="xls-doc-icon"
                                />
                                <i v-else class="exp-doc-file" />
                              </a>
                              <i
                                class="open-conteiner-icon cloud-upload-icon"
                                v-if="doc.IS_VIEW_BACKUP_DOWNLOAD"
                                @click="openDoc(doc.UF_FILE_ID)"
                                style="cursor: pointer"
                              />
                              <sup
                                v-if="doc.UF_IS_NEW && doc.UF_IS_NEW_VIEW"
                                class="new_doc"
                                >новый</sup
                              >
                            </td>
                            <td>
                              <div v-if="doc.UF_IS_VIEW_TIME_UPDATE === 1">
                                {{ doc.UF_DATE_LOAD }}
                                <a>
                                  <i
                                    v-if="doc.UF_IS_VIEW_COMMENT === 1"
                                    class="i-info-commetn"
                                    @click="
                                      openCommentModal(doc.UF_COMMENT_UPDATE)
                                    "
                                  />
                                </a>
                              </div>
                            </td>
                            <td
                              v-if="
                                listQuestionConference.IS_VIEW_CONTROLLER_SET_NEW_SIGN ===
                                  1
                              "
                            >
                              <div class="switch-container">
                                <span
                                  class="switch-text  switch-text-no"
                                  :class="{ checked: !doc.UF_IS_NEW }"
                                >
                                  Нет
                                </span>
                                <label class="switch-box">
                                  <input
                                    type="checkbox"
                                    :checked="doc.UF_IS_NEW"
                                    @change="setIsNew($event, doc.ID)"
                                  />
                                  <span
                                    class="switch-box__slider switch-box__round"
                                  />
                                </label>
                                <span
                                  :class="{ checked: doc.UF_IS_NEW }"
                                  class="switch-text"
                                >
                                  Да
                                </span>
                              </div>
                            </td>
                            <td />
                            <td
                              v-if="
                                listQuestionConference.IS_VIEW_COLUMN_VOITING ===
                                  1
                              "
                            />
                          </tr>
                        </template>
                        <!-- сами документы группы -->
                      </template>
                    </template>
                    <!-- обычный режим вывода документов - плоский список -->
                    <template
                      v-else-if="!item.QUESTION.UF_IS_DELETE_AFTER_VIEW_SOVET"
                    >
                      <tr
                        v-if="item.DOC_LIST"
                        v-for="(doc, index) in item.DOC_LIST"
                        :key="index"
                        class="table-question-list__tbody-tr-result"
                      >
                        <td>{{ doc.UF_SORT }}. {{ doc.UF_NAME }}</td>
                        <td style="min-width: 100px;">
                          <a
                            v-if="
                              doc.UF_IS_AUTO_GENERATE == 1 &&
                                doc.FILE_FULL_INFO !== ''
                            "
                            :href="doc.FILE_FULL_INFO"
                            target="_blank"
                            class="stl-link-black table-doc__status-link"
                            style="cursor: pointer"
                          >
                            <i class="exp-doc-file" />
                          </a>
                          <div
                            v-else-if="doc.UF_IS_AUTO_GENERATE == 1"
                            @click="openGeneretaDoc(doc.ID)"
                            class="stl-link-black"
                            style="cursor: pointer"
                          >
                            <i class="exp-doc-file" />
                          </div>
                          <a
                            v-else-if="doc.FILE_FULL_INFO != ''"
                            :href="doc.FILE_FULL_INFO"
                            target="_blank"
                            class="stl-link-black table-doc__status-link"
                            style="text-decoration: none;cursor: pointer"
                          >
                            <i
                              v-if="doc.UF_EXT === 'pdf'"
                              class="exp-doc-file"
                            />
                            <i
                              v-else-if="
                                doc.UF_EXT === 'doc' || doc.UF_EXT === 'docx'
                              "
                              class="docs-doc-icon-sovet"
                            />
                            <i
                              v-else-if="
                                doc.UF_EXT === 'xls' || doc.UF_EXT === 'xlsx'
                              "
                              class="xls-doc-icon"
                            />
                            <i v-else class="exp-doc-file" />
                          </a>
                          <a
                            v-else-if="doc.UF_FILE_ID > 0"
                            @click="openDoc(doc.UF_FILE_ID)"
                            class="stl-link-black table-doc__status-link"
                            style="text-decoration: none;cursor: pointer"
                          >
                            <i
                              v-if="doc.UF_EXT === 'pdf'"
                              class="exp-doc-file"
                            />
                            <i
                              v-else-if="
                                doc.UF_EXT === 'doc' || doc.UF_EXT === 'docx'
                              "
                              class="docs-doc-icon-sovet"
                            />
                            <i
                              v-else-if="
                                doc.UF_EXT === 'xls' || doc.UF_EXT === 'xlsx'
                              "
                              class="xls-doc-icon"
                            />
                            <i v-else class="exp-doc-file" />
                          </a>

                          <!--<a
                        v-if="doc.UF_FILE_ID > 0"
                        @click="openDoc(doc.UF_FILE_ID)"
                        class="stl-link-black table-doc__status-link"
                      >
                        <i v-if="doc.UF_EXT === 'pdf'" class="exp-doc-file" />
                        <i
                          v-if="doc.UF_EXT === 'doc' || doc.UF_EXT === 'docx'"
                          class="docs-doc-icon"
                        />
                        <i
                          v-if="doc.UF_EXT === 'xls' || doc.UF_EXT === 'xlsx'"
                          class="xls-doc-icon"
                        />
                        {{ doc.UF_FILE_NAME }}
                      </a>-->
                          &nbsp;
                          <i
                            class="open-conteiner-icon cloud-upload-icon"
                            v-if="doc.IS_VIEW_BACKUP_DOWNLOAD"
                            @click="openDoc(doc.UF_FILE_ID)"
                            style="cursor: pointer"
                          />
                          <sup
                            v-if="doc.UF_IS_NEW && doc.UF_IS_NEW_VIEW"
                            class="new_doc"
                            >новый</sup
                          >
                        </td>
                        <td>
                          <div v-if="doc.UF_IS_VIEW_TIME_UPDATE === 1">
                            {{ doc.UF_DATE_LOAD }}
                            <a>
                              <i
                                v-if="doc.UF_IS_VIEW_COMMENT === 1"
                                class="i-info-commetn"
                                @click="openCommentModal(doc.UF_COMMENT_UPDATE)"
                              />
                            </a>
                          </div>
                        </td>
                        <td
                          v-if="
                            listQuestionConference.IS_VIEW_CONTROLLER_SET_NEW_SIGN ===
                              1
                          "
                        >
                          <div class="switch-container">
                            <span
                              class="switch-text  switch-text-no"
                              :class="{ checked: !doc.UF_IS_NEW }"
                            >
                              Нет
                            </span>
                            <label class="switch-box">
                              <input
                                type="checkbox"
                                :checked="doc.UF_IS_NEW"
                                @change="setIsNew($event, doc.ID)"
                              />
                              <span
                                class="switch-box__slider switch-box__round"
                              />
                            </label>
                            <span
                              :class="{ checked: doc.UF_IS_NEW }"
                              class="switch-text"
                            >
                              Да
                            </span>
                          </div>
                        </td>
                        <td />
                        <td
                          v-if="
                            listQuestionConference.IS_VIEW_COLUMN_VOITING === 1
                          "
                        />
                      </tr>
                    </template>
                  </tbody>
                  <tbody class="table-question-list__tbody active">
                    <tr class="table-question-list__tbody-container">
                      <td colspan="4" class="table-question-list__tbody-name" />
                      <td
                        v-if="
                          listQuestionConference.IS_VIEW_CONTROLLER_SET_NEW_SIGN ===
                            1
                        "
                      />
                      <td
                        v-if="
                          listQuestionConference.IS_VIEW_COLUMN_VOITING === 1 &&
                            listQuestionConference.IS_VIEW_BUTTON_VOITING_ALL ===
                              1
                        "
                        class="table-question-list__tbody-button"
                      >
                        <div class="vote-controll df-ac">
                          <button
                            v-for="(voice,
                            index) in listQuestionConference.SP_TYPE_VOIСE"
                            :key="index"
                            type="button"
                            :class="[
                              listQuestionConference.IS_ACTIVE_AREA_VOITING
                                ? ''
                                : 'butt-vote-disabled',
                              voice.UF_CLASS_BUTTON
                            ]"
                            :disabled="
                              !listQuestionConference.IS_ACTIVE_AREA_VOITING
                            "
                            @click="
                              setVoiceAll(
                                listQuestionConference.EXPERT_SOVET_ID,
                                voice.ID
                              )
                            "
                            class="butt-stl vote-controll-item butt-vote-behind"
                          >
                            Все {{ voice.UF_NAME }}
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <!-- container-col -->
        </div>
      </div>
    </div>

    <!-- Описание изменений в документе -->
    <div
      class="modal fade in"
      :class="{ show: isViewCommentModal }"
      id="info-vote-modal"
      tabindex="-1"
      role="dialog"
    >
      <form>
        <div
          class="modal-dialog modal-new-style modal-close-active"
          role="document"
        >
          <div class="modal-content">
            <div class="modal-header">
              <button
                type="button"
                @click="closeCommentModal"
                class="close"
                aria-label="Close"
                data-dismiss="modal"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">
                Описание изменений в документе
              </h4>
            </div>
            <div class="modal-body" style="margin-bottom: 0px;">
              <div class="form-group">
                <div class="info-vote-modal__history">
                  <p>
                    {{ docsComment }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </form>
    </div>
    <!-- /.modal -->
    <!-- Описание изменений в документе -->

    <!-- История статусов голосования -->
    <div
      class="modal fade in"
      :class="{ show: isViewHistoryModal }"
      id="info-vote-modal"
      tabindex="-1"
      role="dialog"
    >
      <form>
        <div
          class="modal-dialog modal-new-style modal-close-active"
          role="document"
        >
          <div class="modal-content" v-if="elementTemp.QUESTION">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                aria-label="Close"
                data-dismiss="modal"
                @click="closeHistoryModal"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">
                История статусов голосования по вопросу №
                {{ elementTemp.QUESTION.UF_SORT }}
                {{ elementTemp.QUESTION.UF_NAME }}
              </h4>
            </div>
            <div class="modal-body" style="margin-bottom: 0px;">
              <div class="form-group">
                <div
                  v-for="(item, index) in historyStatusTemp"
                  :key="index"
                  class="info-vote-modal__history"
                >
                  <p>
                    {{ item.UF_TIMESTAMP_X }}
                    {{ listQuestionConference.EXPERT_LIST[item.UF_EXPERT_ID] }}
                    выбрал "{{ item.TYPE_VOICE_RESULT_NAME }}"
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </form>
    </div>
    <!-- /.modal -->
    <!-- История статусов голосования -->

    <!-- ЗАГРУЗКА ФАЙЛА СОСТАВА СОВЕТА -->
    <div
      class="modal fade in"
      :class="{ show: showUploaderSovetFile }"
      tabindex="-1"
      role="dialog"
    >
      <form action="#" @submit.prevent="submit" style="padding-right: 20px">
        <div
          role="document"
          class="modal-dialog modal-new-style modal-close-active"
        >
          <div class="modal-content">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                aria-label="Close"
                data-dismiss="modal"
                @click="showUploaderSovetFile = !showUploaderSovetFile"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">
                {{ listQuestionConference.TEXT_FILE_SOSTAV_SOVET }}
              </h4>
            </div>
            <div class="modal-body" style="margin-bottom: 0px;">
              <div class="form-group">
                <div class="upload-file-area">
                  <input
                    class="upload-file-area__input"
                    type="file"
                    name="file"
                    id="inp-file-expert-doc"
                    ref="file"
                    @change="changeFile"
                  />
                  <label
                    for="inp-file-expert-doc"
                    class="upload-file-area__label"
                    v-if="fileName"
                  >
                    <span class="upload-file-area__text">
                      <i class="icon-item icon-img-upload"></i>
                      <span v-text="fileName"></span>
                      <span v-text="fileName2"></span>
                    </span>

                    <button
                      v-if="fileName2"
                      class="butt-stl butt-red upload-file-area__btn-remove"
                      type="button"
                      @click="clearFileSovet"
                    >
                      Удалить
                    </button>
                  </label>
                </div>
                <div class="alert alert-info">
                  Максимальный размер файла для загрузки - 100 Мб.
                </div>

                <div v-if="errorText" class="alert alert-danger">
                  {{ errorText }}
                </div>
                <div
                  v-for="err in errorArr"
                  class="alert alert-danger"
                  style="margin-top: 10px"
                >
                  {{ err.TEXT }}
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="submit" class="butt-stl butt-blue">
                Сохранить
              </button>
              <button
                type="button"
                data-dismiss="modal"
                class="butt-stl butt-black"
                @click="showUploaderSovetFile = false"
              >
                Отмена
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
    <!-- зАГРУЗКА фАЙЛА СОСТАВА СОВЕТА-->

    <!-- Удалить файл совета -->
    <div
      class="modal fade in"
      tabindex="-1"
      :class="{ show: showDialogDeleteFileSovet }"
      role="dialog"
    >
      <form>
        <div class="modal-dialog modal-new-style" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">Удалить файл состава совета</h4>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <p>
                  Вы действительно хотите удалить файл "{{
                    listQuestionConference.TEXT_FILE_SOSTAV_SOVET
                  }}"? Данное действие невозможно будет отменить.
                </p>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="butt-stl butt-black"
                data-dismiss="modal"
                v-on:click="showDialogDeleteFileSovet = false"
              >
                отменить
              </button>
              <button
                type="button"
                v-on:click="deleteFileSovet()"
                class="butt-stl butt-red"
              >
                Удалить
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </form>
    </div>
    <!-- /.modal -->
    <!-- Удалить файл совета -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { FETCH_LIST_QUESTION_CONFERENCE } from "@/store/actions.type";
import { ExpertAdvice } from "@/common/api.service";
import { AUTH_URL } from "@/common/config";
//import Vue from "vue";

export default {
  name: "ConferencePage",
  data() {
    return {
      doc: "",
      filter: {
        UF_TYPE_SOVET_ID: "",
        ID: ""
      },
      isViewCommentModal: false,
      isViewHistoryModal: false,
      docsComment: "",
      isCloseRowQuestionArr: {},
      isCloseRowQuestionArrDopDoc: {},
      historyStatusTemp: "",
      elementTemp: "",
      isResetPhilter: 0,
      showUploaderSovetFile: false,
      fileName: "Файл не выбран",
      fileName2: "",
      errorArr: [],
      errorText: "",
      uploadBlockButton: false,
      showDialogDeleteFileSovet: false,
      isDesktop: false,
      isSmail: false,
      isLoading: false
    };
  },
  computed: {
    ...mapGetters([
      "listQuestionConference",
      "isListQuestionConference",
      "directory",
      "currentUser"
    ]),
    getSpNumberSovet() {
      let obj = {};
      Object.keys(this.listQuestionConference.SP_NUMBER_SOVET).forEach(key => {
        if (
          this.listQuestionConference.SP_NUMBER_SOVET[key].UF_TYPE_SOVET_ID ===
          this.filter.UF_TYPE_SOVET_ID
        ) {
          obj[key] = this.listQuestionConference.SP_NUMBER_SOVET[key];
        }
      });

      if (this.listQuestionConference.SP_TYPE_SOVET) {
        if (this.listQuestionConference.SP_TYPE_SOVET.length == 1) {
          this.setDefaultFilter();
        }
      }

      return obj;
    }
  },
  async mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    if (
      this.$parent.setPhilter &&
      this.listQuestionConference.DEFAULT_PHILTER
    ) {
      this.filter.UF_TYPE_SOVET_ID = this.listQuestionConference.DEFAULT_PHILTER.UF_TYPE_SOVET_ID;
      this.filter.ID = this.listQuestionConference.DEFAULT_PHILTER.ID;
    }
    this.fetchItems();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  watch: {},
  methods: {
    handleResize() {
      const width = window.innerWidth;
      this.isDesktop = width > 1220;
      this.isSmail = width < 901;
    },
    createCloseArr() {
      this.isCloseRowQuestionArr = this.listQuestionConference.VIEW_CLOSE;
    },
    closeQuestion(id) {
      if (!this.isCloseRowQuestionArr) {
        this.createCloseArr();
      }
      this.isCloseRowQuestionArr[id] = !this.isCloseRowQuestionArr[id];
    },
    createCloseArrDopDoc() {
      this.isCloseRowQuestionArrDopDoc = this.listQuestionConference.VIEW_CLOSE_DOP_DOC;
    },
    closeDopDocByQuestion(id, event) {
      event.preventDefault();
      if (!this.isCloseRowQuestionArrDopDoc) {
        this.createCloseArrDopDoc();
      }
      this.isCloseRowQuestionArrDopDoc[id] = !this.isCloseRowQuestionArrDopDoc[
        id
      ];
      console.log(this.isCloseRowQuestionArrDopDoc);
    },
    openDoc(id) {
      ExpertAdvice.getLinkByFileAdvise(id).then(({ data }) => {
        window.location.href =
          AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link;
        /*window.open(
          AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link,
          "_blank"
        );*/
      });
    },
    openGeneretaDoc(id) {
      ExpertAdvice.getLinkByFileGenerateAdvise(id).then(({ data }) => {
        window.location.href =
          AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link;
        /*window.open(
          AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link,
          "_blank"
        );*/
      });
    },
    moveBack() {
      this.$router.push({
        name: "EAList",
        params: { id: this.$route.params.id }
      });
    },
    openHistoryModal(item, id) {
      this.historyStatusTemp = item.VOTE_USER_INFO[id].HISTORY;
      this.elementTemp = item;
      this.isViewHistoryModal = true;
    },
    closeHistoryModal() {
      this.isViewHistoryModal = false;
    },
    resetSpNumber() {
      this.filter.ID = "";
    },
    resetFilters() {
      this.filter = {
        UF_TYPE_SOVET_ID: "",
        ID: ""
      };
      this.$parent.setPhilter = false;
      this.isResetPhilter = 1;
      this.fetchItems();
    },
    openCommentModal(doc) {
      this.docsComment = doc;
      this.isViewCommentModal = true;
    },
    closeCommentModal() {
      this.docsComment = "";
      this.isViewCommentModal = false;
    },
    setIsNew(event, id) {
      ExpertAdvice.setIsNewDocuments(id, {
        UF_IS_NEW: Number(event.target.checked)
      }).then(({ data }) => {
        if (data.errorArr && data.errorArr.length) {
          this.$toasted.show(data.errorArr[0].TEXT, {
            theme: "red",
            position: "bottom-right",
            duration: 3500
          });
        } else {
          this.fetchItemsSetNew();
        }
      }, this);
    },
    getArchive(id) {
      ExpertAdvice.getLinkFileArchive(id).then(({ data }) => {
        window.location.href =
          AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link;
      }, this);
    },
    getArchiveAll() {
      ExpertAdvice.getLinkFileArchiveAll(
        this.listQuestionConference.EXPERT_SOVET_ID
      ).then(({ data }) => {
        window.location.href =
          AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link;
      }, this);
    },

    setVoice(id, vote, voteLastID) {
      if (vote != voteLastID) {
        ExpertAdvice.setVoice(id, { UF_RESULT_VOTE_ID: vote }).then(
          ({ data }) => {
            if (data.errorArr && data.errorArr.length) {
              this.$toasted.show(data.errorArr[0].TEXT, {
                theme: "red",
                position: "bottom-right",
                duration: 3500
              });
            } else {
              this.fetchItems();
            }
          },
          this
        );
      }
    },
    setVoiceAll(idSovet, vote) {
      ExpertAdvice.setVoiceAll(idSovet, {
        UF_RESULT_VOTE_ID: vote
      }).then(({ data }) => {
        if (data.errorArr && data.errorArr.length) {
          this.$toasted.show(data.errorArr[0].TEXT, {
            theme: "red",
            position: "bottom-right",
            duration: 3500
          });
        } else {
          this.fetchItems();
        }
      }, this);
    },
    SetPhilter() {
      if (this.filter.ID > 0) {
        if (this.$route.params.id != this.filter.ID) {
          this.$route.params.id = this.filter.ID;
          this.$router.replace({
            path: "/experts/conference/" + this.filter.ID
          });
          this.$parent.setPhilter = true;
        }
        this.fetchItems();
      }
    },
    fetchItemsSetNew() {
      this.$store
        .dispatch(FETCH_LIST_QUESTION_CONFERENCE, {
          idSovet: this.$route.params.id,
          filter: { ...this.filter }
        })
        .then(() => {}, this);
    },
    fetchItems() {
      this.isLoading = true;
      this.$store
        .dispatch(FETCH_LIST_QUESTION_CONFERENCE, {
          idSovet: this.$route.params.id,
          filter: { ...this.filter }
        })
        .then(() => {
          document.title = unescape(this.listQuestionConference.TITLE_PAGE);

          this.createCloseArr();
          if (
            this.isResetPhilter == 1 &&
            this.$route.params.id !=
              this.listQuestionConference.DEFAULT_PHILTER.ID
          ) {
            this.$router.replace({
              path:
                "/experts/conference/" +
                this.listQuestionConference.DEFAULT_PHILTER.ID
            });
            this.isResetPhilter = false;
          }
          this.isLoading = false;
        }, this);

      /*if (
        this.$parent.setPhilter &&
        this.listQuestionConference.DEFAULT_PHILTER
      ) {
        this.filter.UF_TYPE_SOVET_ID = this.listQuestionConference.DEFAULT_PHILTER.UF_TYPE_SOVET_ID;
        this.filter.ID = this.listQuestionConference.DEFAULT_PHILTER.ID;
      }*/
    },
    setDefaultFilter() {
      if (this.listQuestionConference.SP_TYPE_SOVET) {
        if (this.listQuestionConference.SP_TYPE_SOVET.length == 1) {
          this.filter.UF_TYPE_SOVET_ID = this.listQuestionConference.SP_TYPE_SOVET[0].ID;
        }
      }
    },
    sUploaderFileSovet() {
      this.showUploaderSovetFile = !this.showUploaderSovetFile;
      this.typeIndex = -1;
      this.docName = "";
      this.file = "";
      this.fileName = "Файл не выбран";
      this.fileName2 = "";
      this.errorArr = [];
      this.errorText = "";
    },
    clearFileSovet() {
      this.typeIndex = -1;
      this.docName = "";
      this.file = "";
      this.fileName = "Файл не выбран";
      this.fileName2 = "";
      this.errorArr = [];
      this.errorText = "";
    },
    changeFile() {
      let reader = new FileReader();
      (this.errorText = ""), reader.readAsDataURL(this.$refs.file.files[0]);
      reader.onload = () => {
        let file = this.$refs.file.files[0];
        if (file.size < 1024 * 1024 * 100) {
          let header = ";base64,";
          let fileData = reader.result;

          this.fileBase64 = fileData.substr(
            fileData.indexOf(header) + header.length
          );
        } else {
          this.errorText =
            "Загружаемый файл превышает максимально разрешенный размер. Загрузить можно файл размером не более 100 Мб";
        }
      };
      this.fileName = this.$refs.file.files[0].name;
      this.fileName2 = this.fileName;
      this.fileName = "    ";
    },
    submit() {
      this.uploadBlockButton = true; //блокировка кнопки
      if (typeof this.$refs.file.files[0] === "undefined") {
        return false;
      }

      let formData = new FormData();
      formData.append(
        "UF_SOSTAV_SOVET_FILE_ID",
        this.listQuestionConference.SOVET_INFO.UF_SOSTAV_SOVET_FILE_ID
      );
      formData.append("FILE", this.$refs.file.files[0]);

      ExpertAdvice.saveFileSostavSovet(
        this.listQuestionConference.SOVET_INFO.ID,
        formData,
        this.fileForm
      ).then(response => {
        if (!response.data.error) {
          //this.fetchItems();
          this.fetchItemsSetNew();
          this.showUploaderSovetFile = false;
          this.$toasted.show("Файл успешно загружен", {
            theme: "green",
            position: "bottom-right",
            duration: 3500
          });
        } else {
          this.errorArr = response.data.errorArr;
          this.uploadBlockButton = false;
        }
      }, this);
      return false;
    },
    sDeleteFileSovetDialog() {
      this.showDialogDeleteFileSovet = !this.showDialogDeleteFileSovet;
    },
    deleteFileSovet() {
      ExpertAdvice.deleteFileSostavSovet(
        this.listQuestionConference.SOVET_INFO.ID
      ).then(({ data }) => {
        if (data.errorArr && data.errorArr.length) {
          this.$toasted.show(data.errorArr[0].TEXT, {
            theme: "red",
            position: "bottom-right",
            duration: 3500
          });
        } else {
          //this.fetchItems();
          this.fetchItemsSetNew();
          this.$toasted.show("Файл успешно удален", {
            theme: "green",
            position: "bottom-right",
            duration: 3500
          });

          this.showDialogDeleteFileSovet = false;
        }
      }, this);
    }
  },
  async created() {
    this.createCloseArr();
    this.createCloseArrDopDoc();
  }
};
</script>
